import { configureStore } from '@reduxjs/toolkit';

import ui from './ui';
import trail from './trail';

const store = configureStore({
  reducer: {
    ui: ui.reducer,
    trail: trail.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
